<template>
  <section class="pd-t-16 pd-b-16 box">
    <div>
      <p class="color-dark fs-14 fw-600">Internal Summary</p>
      <p
        class="mg-t-15"
        v-html="changeLineText(interSummary)"> </p>
      <p  class="mg-t-15">
        <v-button
          blue
          @click="isShow = true">Edit Summary</v-button>
      </p>
    </div>
    <v-dialog
      v-model="isShow"
      width="400px"
      @closed="closed">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Internal Summary</span>
          <font-awesome-icon
            icon="times"
            class="pointer"
            @click="handleCancel"></font-awesome-icon>
        </div>
        <div class="dialog-body">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules">
            <div class="info">
              <!--              <span class="title">Description</span>-->
              <el-form-item prop="inter_summary">
                <v-input
                  v-model="formData.inter_summary"
                  :rows="5"
                  type="textarea"></v-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleSave">Save</v-button>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import {addDescription} from '@/api/account'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import {editSMESummary} from '@api/new_sme'
export default {
  name: 'EditSummary',
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props:{
    interSummary:{
      type: [String],
      default: ''
    },
    orderId:{
      type: [String,Number],
      default: 0
    },
  },
  data () {
    return {
      isShow: false,
      formData:{
        inter_summary: ''
      }
    }
  },
  watch:{
    // interSummary:{
    //   immediate: true,
    //   handler(val){
    //     console.log('interSummary0----',val)
    //     if(this.isShow)
    //       this.formData.inter_summary = val
    //     // if(val){
    //     //
    //     // }
    //   }
    // },
    isShow:{
      immediate:true,
      handler(val){
        if(val){
          this.formData.inter_summary = this.interSummary
        }

      }
    }
  },
  methods: {
    changeDialog(){
      this.isShow = !this.isShow
    },
    handleCancel(){
      this.isShow = false
    },
    handleSave(){
      this.$refs['form'].validate(valid => {
        if(valid){
          this.network().editSMESummary()
        }
      })
    },
    closed(){
      this.$refs['form'].resetFields()
    },
    network(){
      return {
        editSMESummary: async () => {
          const {data} = await editSMESummary({
            order_id: this.orderId,
            ...this.formData
          })
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.isShow = false
            this.$emit('update')
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    display: flex;
    justify-content: space-between;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .info{
      .title{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
      }
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    padding-top: 0;
  }
}
</style>
